<proffeo-ui-dialog [title]="'company-groups.modals.edit-name-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex w-full gap-2 flex-col">
      <proffeo-ui-input
        [formField]="form.name"
        label="company-groups.modals.form-label-name"
      />
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      variant="primary"
      matDialogClose
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
